<template>
  <div v-if="visible" class="modal-overlay" @click.self="hideModal">
    <div class="modal-box">
      <!-- Header -->
      <div class="d-flex justify-content-between align-items-center mb-3">
        <h5 class="fw-bold mb-0">{{ $t('Trip_Rating') }}</h5>
        <button type="button" class="btn-close" @click="hideModal"></button>
      </div>

      <!-- Content -->
      <div class="border rounded p-3 d-flex justify-content-between align-items-center">
        <div class="text-muted">{{ feedback }}</div>
        <div class="d-flex align-items-center gap-2">
          <i class="bi bi-star-fill text-warning"></i>
          <span class="text-muted">{{ rating }}/5</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    tripId: String,
    rating: Number,
    feedback: String,
  },
  data() {
    return {
      visible: false,
    }
  },
  methods: {
    open() {
      this.visible = true
    },
    hideModal() {
      this.visible = false
    },
  },
}
</script>

<style scoped>
.modal-overlay {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.5);
  z-index: 1050;
  display: flex;
  align-items: center;
  justify-content: center;
}

.modal-box {
  background: #fff;
  border-radius: 0.5rem;
  padding: 20px;
  width: 100%;
  max-width: 500px;
  box-shadow: 0 4px 24px rgba(0, 0, 0, 0.15);
}
</style>
